module.exports = __webpack_public_path__ + "static/media/camera.e0c52de8.svg";